import { network } from 'services/network';

export const roleUpdateByID = (params) => {
    return network.post(`admin/bo/roleUpdateByID/${params.id}`, params.role).then((response) => {
        return response.data;
    });
};
